module.exports = __webpack_public_path__ + "media/day/299-930f4304.svg";